import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import axios from "axios";
import Swal from "sweetalert2";

import ObtieneDatosCookies
  from "../obtieneDatosCookiesUsuario";

const API_BASE =
  "https://wwwa.isepsantafe.net.ar/expedientes";

const API_DOCUMENTOS =
  "https://wwwa.isepsantafe.net.ar/documentacionAusenciasDocentes";

const TZ =
  "America/Argentina/Buenos_Aires";

const obtenerDiasConfirmados = (carpeta) => {
  const candidatos = [
    carpeta?.diasConfirmados,
    carpeta?.avisoDocente?.diasConfirmados,
    carpeta?.aviso?.diasConfirmados,
    carpeta?.avisoAusenciaDocente?.diasConfirmados,
  ];

  const valor = candidatos.find(
    (item) => item !== null && item !== undefined && item !== ""
  );

  if (valor === undefined) return null;

  const numero = Number(valor);
  return Number.isNaN(numero) ? valor : numero;
};

// ============================================================
// COMPONENTE
// ============================================================

const ModuloSanidadAusenciasDocentes = () => {
  const Usuario =
    ObtieneDatosCookies();

  const [carpetas, setCarpetas] =
    useState([]);

  const [cargando, setCargando] =
    useState(false);

  const [busqueda, setBusqueda] =
    useState("");

  const [
    carpetaExpandidaId,
    setCarpetaExpandidaId,
  ] = useState(null);

  const [
    guardandoIntervencion,
    setGuardandoIntervencion,
  ] = useState(false);

  const [
    guardandoDocumentoId,
    setGuardandoDocumentoId,
  ] = useState(null);

  const [
    filtroPrioridad,
    setFiltroPrioridad,
  ] = useState("todos");

  const [verTodos, setVerTodos] =
    useState(false);

  // ============================================================
  // CARGAR CASOS
  // ============================================================

  const cargarCarpetas = async () => {
    try {
      setCargando(true);

      const response =
        await axios.post(
          `${API_BASE}/devuelveAusenciasDocentesSanidad`,
          {},
          {
            withCredentials: true,
          }
        );

     
      const lista =
        response.data?.carpetas ||
        response.data?.data ||
        response.data ||
        [];

      const listaFinal =
        Array.isArray(lista)
          ? lista
          : [];

      setCarpetas(listaFinal);

      return listaFinal;
    } catch (error) {
      console.error(
        "Error cargando Sanidad:",
        error
      );

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data
            ?.message ||
          "No se pudieron obtener las licencias docentes.",
      });

      return [];
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarCarpetas();
  }, []);

  // ============================================================
  // HOY EN ARGENTINA
  // ============================================================

  const obtenerHoyArgentina =
    () => {
      const partes =
        new Intl.DateTimeFormat(
          "en-US",
          {
            timeZone: TZ,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }
        ).formatToParts(
          new Date()
        );

      const obtener =
        (tipo) =>
          partes.find(
            (p) =>
              p.type === tipo
          )?.value;

      return {
        anio: Number(
          obtener("year")
        ),
        mes: Number(
          obtener("month")
        ),
        dia: Number(
          obtener("day")
        ),
      };
    };

  const hoyLocal =
    useMemo(() => {
      const hoy =
        obtenerHoyArgentina();

      return new Date(
        hoy.anio,
        hoy.mes - 1,
        hoy.dia,
        12,
        0,
        0,
        0
      );
    }, []);

  // ============================================================
  // PARSEAR FECHA CALENDARIO
  // ============================================================

  const fechaCalendario =
    (fecha) => {
      if (!fecha) {
        return null;
      }

      const texto =
        String(fecha).trim();

      const match =
        texto.match(
          /^(\d{4})-(\d{2})-(\d{2})/
        );

      if (!match) {
        return null;
      }

      return new Date(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3]),
        12,
        0,
        0,
        0
      );
    };

  // ============================================================
  // DIFERENCIA EN DÍAS
  // ============================================================

  const diferenciaDias =
    (fecha) => {
      const obj =
        fechaCalendario(
          fecha
        );

      if (!obj) {
        return null;
      }

      const MS_DIA =
        1000 *
        60 *
        60 *
        24;

      return Math.round(
        (
          obj.getTime() -
          hoyLocal.getTime()
        ) /
          MS_DIA
      );
    };

  // ============================================================
  // FORMATEAR FECHA
  // ============================================================

  const formatearFecha =
    (fecha) => {
      if (!fecha) {
        return "-";
      }

      const obj =
        fechaCalendario(
          fecha
        );

      if (obj) {
        return obj.toLocaleDateString(
          "es-AR"
        );
      }

      return String(fecha);
    };

  // ============================================================
  // FECHA + HORA
  // ============================================================

  const formatearFechaHora =
    (fecha) => {
      if (!fecha) {
        return "-";
      }

      try {
        const obj =
          new Date(fecha);

        if (
          Number.isNaN(
            obj.getTime()
          )
        ) {
          return String(fecha);
        }

        return obj.toLocaleString(
          "es-AR",
          {
            timeZone: TZ,
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          }
        );
      } catch {
        return String(fecha);
      }
    };

  // ============================================================
  // TIPO AUSENCIA
  // ============================================================

  const formatearTipoAusencia =
    (tipo) => {
      if (!tipo) {
        return "-";
      }

      const mapa = {
        razonesMedicas:
          "Razones médicas",

        razonMedica:
          "Razón médica",

        enfermedad:
          "Enfermedad",

        imprevisto:
          "Imprevisto",

        razonesPersonales:
          "Razones personales",

        capacitacion:
          "Capacitación",
      };

      if (mapa[tipo]) {
        return mapa[tipo];
      }

      return String(tipo)
        .replace(
          /([A-Z])/g,
          " $1"
        )
        .replace(/_/g, " ")
        .trim()
        .replace(
          /^./,
          (letra) =>
            letra.toUpperCase()
        );
    };

  // ============================================================
  // ESCAPAR HTML SWEETALERT
  // ============================================================

  const escaparHtml =
    (valor) =>
      String(
        valor ?? ""
      )
        .replace(
          /&/g,
          "&amp;"
        )
        .replace(
          /</g,
          "&lt;"
        )
        .replace(
          />/g,
          "&gt;"
        )
        .replace(
          /"/g,
          "&quot;"
        )
        .replace(
          /'/g,
          "&#039;"
        );

  // ============================================================
  // ESTADO PENDIENTE DE SANIDAD
  // ============================================================

  const estaPendiente =
    (carpeta) =>
      [
        "Pendiente",
        "En Revision",
      ].includes(
        carpeta
          ?.estadoSanidad
      );

  // ============================================================
  // ESTADO RESUELTO
  // ============================================================

  const estaResuelta =
    (carpeta) =>
      [
        "Justificado",
        "Injustificado",
      ].includes(
        carpeta
          ?.estadoSanidad
      );

  // ============================================================
  // PRIORIDAD TEMPORAL
  // ============================================================

  const obtenerPrioridad =
    (carpeta) => {
      const pendiente =
        estaPendiente(
          carpeta
        );

      const resuelta =
        estaResuelta(
          carpeta
        );

      const diasInicio =
        diferenciaDias(
          carpeta.fechaDesde
        );

      const diasFin =
        diferenciaDias(
          carpeta.fechaHasta
        );

      // --------------------------------------------------------
      // RESUELTOS
      // --------------------------------------------------------

      if (resuelta) {
        return {
          clave:
            "ocurridos",

          titulo:
            "Ocurrido / resuelto",

          descripcion:
            diasFin !==
              null &&
            diasFin < 0
              ? `Finalizó hace ${Math.abs(
                  diasFin
                )} día(s)`
              : "Intervención resuelta",
        };
      }

      // --------------------------------------------------------
      // CRÍTICO
      // --------------------------------------------------------

      if (
        pendiente &&
        diasInicio !==
          null &&
        diasInicio <= 0
      ) {
        if (
          diasFin !==
            null &&
          diasFin < 0
        ) {
          return {
            clave:
              "criticos",

            titulo:
              "Crítico · vencido",

            descripcion:
              `La ausencia terminó hace ${Math.abs(
                diasFin
              )} día(s) y sigue sin resolución`,
          };
        }

        if (
          diasInicio === 0
        ) {
          return {
            clave:
              "criticos",

            titulo:
              "Crítico · comienza hoy",

            descripcion:
              "Requiere intervención inmediata",
          };
        }

        return {
          clave:
            "criticos",

          titulo:
            "Crítico · en curso",

          descripcion:
            `Comenzó hace ${Math.abs(
              diasInicio
            )} día(s)`,
        };
      }

      // --------------------------------------------------------
      // PRÓXIMOS 7 DÍAS
      // --------------------------------------------------------

      if (
        pendiente &&
        diasInicio !==
          null &&
        diasInicio > 0 &&
        diasInicio <= 7
      ) {
        return {
          clave:
            "proximos",

          titulo:
            "Próximo",

          descripcion:
            diasInicio === 1
              ? "Comienza mañana"
              : `Comienza en ${diasInicio} días`,
        };
      }

      // --------------------------------------------------------
      // POSTERIORES
      // --------------------------------------------------------

      if (pendiente) {
        return {
          clave:
            "posteriores",

          titulo:
            "Posterior",

          descripcion:
            diasInicio !==
              null
              ? `Comienza en ${diasInicio} días`
              : "Fecha pendiente de clasificación",
        };
      }

      // --------------------------------------------------------
      // OTROS
      // --------------------------------------------------------

      return {
        clave:
          "otros",

        titulo:
          "Sin prioridad",

        descripcion:
          "No requiere intervención inmediata",
      };
    };

  // ============================================================
  // FILTRAR BÚSQUEDA
  // ============================================================

  const carpetasFiltradasBusqueda =
    useMemo(() => {
      const texto =
        busqueda
          .trim()
          .toLowerCase();

      if (!texto) {
        return carpetas;
      }

      return carpetas.filter(
        (carpeta) => {
          const docente =
            carpeta.docente ||
            {};

          const info =
            carpeta
              .informacionAcademica ||
            {};

          const prioridad =
            obtenerPrioridad(
              carpeta
            );

          const valores = [
            carpeta.carpetaId,
            carpeta.docenteDni,

            docente.apellido,
            docente.nombres,
            docente.nombreCompleto,

            carpeta
              .tipoDeAusencia,

            carpeta
              .estadoGeneral,

            carpeta
              .estadoSanidad,

            carpeta
              .observacionesSanidad,

            info.materia,
            info.curso,
            info.division,
            info.sede,
            info.escuela,

            prioridad.titulo,
          ];

          return valores.some(
            (valor) =>
              String(
                valor || ""
              )
                .toLowerCase()
                .includes(
                  texto
                )
          );
        }
      );
    }, [
      carpetas,
      busqueda,
    ]);

  // ============================================================
  // RESUMEN
  // ============================================================

  const resumen =
    useMemo(() => {
      const resultado = {
        total: 0,
        criticos: 0,
        proximos: 0,
        posteriores: 0,
        ocurridos: 0,
        pendientes: 0,
        resueltos: 0,
      };

      carpetasFiltradasBusqueda.forEach(
        (carpeta) => {
          resultado.total++;

          const prioridad =
            obtenerPrioridad(
              carpeta
            );

          if (
            resultado[
              prioridad.clave
            ] !== undefined
          ) {
            resultado[
              prioridad.clave
            ]++;
          }

          if (
            estaPendiente(
              carpeta
            )
          ) {
            resultado.pendientes++;
          }

          if (
            estaResuelta(
              carpeta
            )
          ) {
            resultado.resueltos++;
          }
        }
      );

      return resultado;
    }, [
      carpetasFiltradasBusqueda,
    ]);

  // ============================================================
  // APLICAR FILTRO DE PRIORIDAD
  // ============================================================

  const carpetasVisibles =
    useMemo(() => {
      let lista =
        carpetasFiltradasBusqueda;

      // Por defecto mostramos solamente los casos
      // que Sanidad todavía debe resolver.
      if (!verTodos) {
        lista = lista.filter(
          (carpeta) =>
            estaPendiente(carpeta)
        );
      }

      // Luego aplicamos, si corresponde,
      // el filtro de prioridad seleccionado.
      if (
        filtroPrioridad !==
        "todos"
      ) {
        lista = lista.filter(
          (carpeta) =>
            obtenerPrioridad(
              carpeta
            ).clave ===
            filtroPrioridad
        );
      }

      return lista;
    }, [
      carpetasFiltradasBusqueda,
      filtroPrioridad,
      verTodos,
    ]);

  // ============================================================
  // ORDENAR POR PRIORIDAD / FECHA
  // ============================================================

  const carpetasOrdenadas =
    useMemo(() => {
      const peso = {
        criticos: 1,
        proximos: 2,
        posteriores: 3,
        ocurridos: 4,
        otros: 5,
      };

      return [
        ...carpetasVisibles,
      ].sort(
        (a, b) => {
          const pa =
            obtenerPrioridad(
              a
            ).clave;

          const pb =
            obtenerPrioridad(
              b
            ).clave;

          if (
            peso[pa] !==
            peso[pb]
          ) {
            return (
              peso[pa] -
              peso[pb]
            );
          }

          const fa =
            fechaCalendario(
              a.fechaDesde
            )?.getTime() ||
            0;

          const fb =
            fechaCalendario(
              b.fechaDesde
            )?.getTime() ||
            0;

          return fa - fb;
        }
      );
    }, [
      carpetasVisibles,
    ]);

  // ============================================================
  // AGRUPAR
  //
  // PRIORIDAD
  //   → ESCUELA
  //   → SEDE
  //   → CURSO
  //   → DIVISIÓN
  // ============================================================

  const grupos =
    useMemo(() => {
      const resultado =
        {};

      carpetasOrdenadas.forEach(
        (carpeta) => {
          const prioridad =
            obtenerPrioridad(
              carpeta
            );

          const info =
            carpeta
              .informacionAcademica ||
            {};

          const escuela =
            info.escuela ||
            "Escuela no informada";

          const sede =
            info.sede ||
            "Sede no informada";

          const curso =
            info.curso ||
            "Curso no informado";

          const division =
            info.division ||
            "Sin división";

          if (
            !resultado[
              prioridad.clave
            ]
          ) {
            resultado[
              prioridad.clave
            ] = {};
          }

          if (
            !resultado[
              prioridad.clave
            ][escuela]
          ) {
            resultado[
              prioridad.clave
            ][escuela] =
              {};
          }

          if (
            !resultado[
              prioridad.clave
            ][escuela][sede]
          ) {
            resultado[
              prioridad.clave
            ][escuela][sede] =
              {};
          }

          if (
            !resultado[
              prioridad.clave
            ][escuela][sede][
              curso
            ]
          ) {
            resultado[
              prioridad.clave
            ][escuela][sede][
              curso
            ] = {};
          }

          if (
            !resultado[
              prioridad.clave
            ][escuela][sede][
              curso
            ][division]
          ) {
            resultado[
              prioridad.clave
            ][escuela][sede][
              curso
            ][division] =
              [];
          }

          resultado[
            prioridad.clave
          ][escuela][sede][
            curso
          ][division].push(
            carpeta
          );
        }
      );

      return resultado;
    }, [
      carpetasOrdenadas,
    ]);

  // ============================================================
  // REFRESCAR CARPETA
  // ============================================================

  const refrescarCarpeta =
    async (carpetaId) => {
      const lista =
        await cargarCarpetas();

      const encontrada =
        lista.find(
          (item) =>
            Number(
              item.carpetaId
            ) ===
            Number(
              carpetaId
            )
        );

      if (
        encontrada &&
        carpetaExpandidaId ===
          carpetaId
      ) {
        // La vista usa directamente
        // el estado carpetas actualizado.
      }
    };

  // ============================================================
  // INTERVENIR
  // ============================================================

  const intervenirSanidad =
    async (
      carpeta,
      estado
    ) => {
      if (
        !carpeta
          ?.carpetaId
      ) {
        return;
      }

      if (!Usuario?.id) {
        Swal.fire({
          icon: "error",
          title:
            "Usuario no identificado",
          text:
            "No se pudo determinar el usuario interviniente.",
        });

        return;
      }

      const requiereObservacion =
        estado ===
        "Injustificado";

      const solicitaDias =
        estado ===
        "Justificado";

      const diasSolicitados =
        Number(
          carpeta
            .diasSolicitados ||
            0
        );

      const diasConfirmadosActuales = obtenerDiasConfirmados(carpeta);
      const diasActuales =
        diasConfirmadosActuales !== null
          ? diasConfirmadosActuales
          : diasSolicitados;

      const nombreAccion = {
        "En Revision":
          "Tomar en revisión",

        Justificado:
          "Justificar ausencia",

        Injustificado:
          "Declarar injustificada",
      };

      let html = `
        <div
          style="
            text-align:left;
            padding:12px;
            background:#fafafa;
            border:1px solid #e5e5e5;
            border-radius:8px;
            line-height:1.7;
          "
        >
          <b>Docente:</b>
          ${escaparHtml(
            carpeta.docente
              ?.nombreCompleto ||
              carpeta.docenteDni
          )}

          <br/>

          <b>Carpeta:</b>
          #${carpeta.carpetaId}

          <br/>

          <b>Período:</b>
          ${formatearFecha(
            carpeta.fechaDesde
          )}
          al
          ${formatearFecha(
            carpeta.fechaHasta
          )}

          <br/>

          <b>Días solicitados:</b>
          ${diasSolicitados}

          <br/>

          <b>Días otorgados:</b>
          ${diasConfirmadosActuales ?? "Sin resolver"}
        </div>
      `;

      if (
        solicitaDias
      ) {
        html += `
          <div
            style="
              text-align:left;
              margin-top:15px;
              margin-bottom:6px;
              font-weight:700;
            "
          >
            Días a otorgar
          </div>

          <input
            id="sanidad-dias-otorgar"
            type="number"
            min="0"
            max="${diasSolicitados}"
            step="1"
            value="${diasActuales}"
            class="swal2-input"
            style="
              width:100%;
              margin:0;
              box-sizing:border-box;
            "
          />
        `;
      }

      html += `
        <div
          style="
            text-align:left;
            margin-top:15px;
            margin-bottom:6px;
            font-weight:700;
          "
        >
          Observación
          ${
            requiereObservacion
              ? "*"
              : ""
          }
        </div>

        <textarea
          id="sanidad-observacion"
          class="swal2-textarea"
          style="
            width:100%;
            min-height:110px;
            margin:0;
            box-sizing:border-box;
          "
          placeholder="${
            requiereObservacion
              ? "Fundamente el motivo..."
              : "Observación opcional..."
          }"
        >${escaparHtml(
          carpeta
            .observacionesSanidad ||
            ""
        )}</textarea>
      `;

      const resultado =
        await Swal.fire({
          title:
            nombreAccion[
              estado
            ],

          html,

          width: 600,

          icon:
            estado ===
            "Justificado"
              ? "success"
              : estado ===
                "Injustificado"
              ? "warning"
              : "question",

          showCancelButton:
            true,

          confirmButtonText:
            "Confirmar",

          cancelButtonText:
            "Cancelar",

          allowOutsideClick:
            false,

          preConfirm:
            () => {
              const observacion =
                document
                  .getElementById(
                    "sanidad-observacion"
                  )
                  ?.value
                  ?.trim() ||
                "";

              if (
                requiereObservacion &&
                !observacion
              ) {
                Swal
                  .showValidationMessage(
                    "Debe ingresar una observación."
                  );

                return false;
              }

              let diasConfirmados =
                null;

              if (
                solicitaDias
              ) {
                const valor =
                  document
                    .getElementById(
                      "sanidad-dias-otorgar"
                    )
                    ?.value;

                const dias =
                  Number(valor);

                if (
                  valor === "" ||
                  Number.isNaN(
                    dias
                  ) ||
                  dias < 0 ||
                  !Number.isInteger(
                    dias
                  )
                ) {
                  Swal
                    .showValidationMessage(
                      "Ingrese una cantidad de días válida."
                    );

                  return false;
                }

                if (
                  dias >
                  diasSolicitados
                ) {
                  Swal
                    .showValidationMessage(
                      `No puede otorgar más de ${diasSolicitados} días.`
                    );

                  return false;
                }

                diasConfirmados =
                  dias;
              }

              if (
                estado ===
                "Injustificado"
              ) {
                diasConfirmados =
                  0;
              }

              return {
                observacion,
                diasConfirmados,
              };
            },
        });

      if (
        !resultado
          .isConfirmed
      ) {
        return;
      }

      try {
        setGuardandoIntervencion(
          true
        );

        const response =
          await axios.post(
            `${API_BASE}/intervenirAusenciaDocenteSanidad`,
            {
              // Datos propios de la intervención sobre la carpeta.
              intervencion: {
                carpetaId:
                  carpeta
                    .carpetaId,

                estado,

                observacion:
                  resultado
                    .value
                    ?.observacion ||
                  "",

                usuarioId:
                  Usuario.id,
              },

              // Campo independiente: pertenece a avisoAusenciaDocente.
              diasConfirmados:
                resultado
                  .value
                  ?.diasConfirmados ??
                null,
            },
            {
              withCredentials:
                true,
            }
          );

        if (
          !response.data
            ?.success
        ) {
          throw new Error(
            response.data
              ?.message ||
              "No se pudo registrar."
          );
        }

        await Swal.fire({
          icon: "success",
          title:
            "Intervención registrada",
          text:
            response.data
              ?.message ||
            "La intervención fue registrada correctamente.",
          timer: 1800,
          showConfirmButton:
            false,
        });

        await refrescarCarpeta(
          carpeta.carpetaId
        );
      } catch (error) {
        Swal.fire({
          icon: "error",
          title:
            "No se pudo intervenir",
          text:
            error.response
              ?.data
              ?.message ||
            error.message ||
            "Ocurrió un error.",
        });
      } finally {
        setGuardandoIntervencion(
          false
        );
      }
    };

  // ============================================================
  // DICTAMINAR DOCUMENTACIÓN
  // ============================================================

  const dictaminarDocumento = async (carpeta, documento, estado) => {
    if (!documento?.id || !carpeta?.carpetaId || !Usuario?.id) return;

    const requiereObservacion = ["Observado", "Rechazado"].includes(estado);
    const resultado = await Swal.fire({
      title: `${estado} documento`,
      html: `
        <div style="text-align:left;margin-bottom:8px;font-size:13px;">
          <b>${documento.nombre || `Documento #${documento.id}`}</b>
        </div>
        <textarea
          id="documento-observacion"
          class="swal2-textarea"
          style="width:100%;min-height:100px;margin:0;box-sizing:border-box;"
          placeholder="${requiereObservacion ? "Indique el motivo..." : "Observación opcional..."}"
        >${documento.observaciones || ""}</textarea>
      `,
      icon: estado === "Aceptado" ? "question" : "warning",
      showCancelButton: true,
      confirmButtonText: `Confirmar ${estado.toLowerCase()}`,
      cancelButtonText: "Cancelar",
      preConfirm: () => {
        const observaciones = document
          .getElementById("documento-observacion")
          ?.value
          ?.trim() || "";

        if (requiereObservacion && !observaciones) {
          Swal.showValidationMessage("Debe indicar una observación.");
          return false;
        }

        return { observaciones };
      },
    });

    if (!resultado.isConfirmed) return;

    try {
      setGuardandoDocumentoId(documento.id);

      const response = await axios.put(
        `${API_BASE}/carpetas-ausencias-documentos/${documento.id}`,
        {
          estado,
          observaciones: resultado.value?.observaciones || "",
          usuarioId: Usuario.id,
          area: "Sanidad",
        },
        { withCredentials: true }
      );

      if (response.data?.ok === false) {
        throw new Error(response.data?.message || "No se pudo actualizar el documento.");
      }

      await Swal.fire({
        icon: "success",
        title: "Documento actualizado",
        text: response.data?.message || "El dictamen documental fue registrado.",
        timer: 1700,
        showConfirmButton: false,
      });

      await refrescarCarpeta(carpeta.carpetaId);
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "No se pudo actualizar",
        text: error.response?.data?.message || error.message || "Ocurrió un error.",
      });
    } finally {
      setGuardandoDocumentoId(null);
    }
  };

  // ============================================================
  // CONFIGURACIÓN DE GRUPOS
  // ============================================================

  const configuracionGrupos = [
    {
      clave:
        "criticos",

      titulo:
        "Críticos",

      subtitulo:
        "Ausencias que ya comenzaron o vencieron sin resolución",

      icono: "⚠ ",
    },

    {
      clave:
        "proximos",

      titulo:
        "Próximos",

      subtitulo:
        "Comienzan dentro de los próximos 7 días",

      icono: "▷",
    },

    {
      clave:
        "posteriores",

      titulo:
        "Posteriores",

      subtitulo:
        "Ausencias futuras con más de 7 días de anticipación",

      icono: "→",
    },

    {
      clave:
        "ocurridos",

      titulo:
        "Ocurridos / resueltos",

      subtitulo:
        "Intervenciones ya justificadas o injustificadas",

      icono: "✓",
    },
  ];

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div
      style={
        styles.contenedor
      }
    >
      {/* =====================================================
          HEADER
      ===================================================== */}

      <div
        style={
          styles.header
        }
      >
        <div>
          <h2
            style={
              styles.titulo
            }
          >
            Sanidad · Licencias
            docentes
          </h2>

          <div
            style={
              styles.subtitulo
            }
          >
            Prioridad y seguimiento
            de carpetas médicas
          </div>
        </div>

        <button
          type="button"
          style={
            styles.botonActualizar
          }
          onClick={
            cargarCarpetas
          }
          disabled={
            cargando
          }
        >
          {cargando
            ? "Actualizando..."
            : "Actualizar"}
        </button>
      </div>

      {/* =====================================================
          RESUMEN SUPERIOR
      ===================================================== */}

      <div
        style={
          styles.resumenGrid
        }
      >
        <Resumen
          numero={
            resumen.criticos
          }
          titulo="Críticos"
          descripcion="requieren atención"
          activo={
            filtroPrioridad ===
            "criticos"
          }
          importante
          onClick={() =>
            setFiltroPrioridad(
              filtroPrioridad ===
                "criticos"
                ? "todos"
                : "criticos"
            )
          }
        />

        <Resumen
          numero={
            resumen.proximos
          }
          titulo="Próximos"
          descripcion="dentro de 7 días"
          activo={
            filtroPrioridad ===
            "proximos"
          }
          onClick={() =>
            setFiltroPrioridad(
              filtroPrioridad ===
                "proximos"
                ? "todos"
                : "proximos"
            )
          }
        />

        <Resumen
          numero={
            resumen.posteriores
          }
          titulo="Posteriores"
          descripcion="más de 7 días"
          activo={
            filtroPrioridad ===
            "posteriores"
          }
          onClick={() =>
            setFiltroPrioridad(
              filtroPrioridad ===
                "posteriores"
                ? "todos"
                : "posteriores"
            )
          }
        />

        <Resumen
          numero={
            resumen.ocurridos
          }
          titulo="Ocurridos"
          descripcion={
            verTodos
              ? "casos resueltos"
              : "activar Ver todos"
          }
          activo={
            filtroPrioridad ===
            "ocurridos"
          }
          onClick={
            verTodos
              ? () =>
                  setFiltroPrioridad(
                    filtroPrioridad ===
                      "ocurridos"
                      ? "todos"
                      : "ocurridos"
                  )
              : () => {
                  setVerTodos(true);
                  setFiltroPrioridad(
                    "ocurridos"
                  );
                }
          }
        />

        <Resumen
          numero={
            resumen.pendientes
          }
          titulo="Pendientes"
          descripcion="Sanidad debe resolver"
        />

        <Resumen
          numero={
            resumen.total
          }
          titulo="Total"
          descripcion="carpetas visibles"
          onClick={() =>
            setFiltroPrioridad(
              "todos"
            )
          }
        />
      </div>

      {/* =====================================================
          BUSCADOR
      ===================================================== */}

      <div
        style={
          styles.barraHerramientas
        }
      >
        <input
          type="text"
          value={
            busqueda
          }
          onChange={(e) =>
            setBusqueda(
              e.target.value
            )
          }
          placeholder="Buscar docente, DNI, escuela, sede, curso, división, materia o estado..."
          style={
            styles.buscador
          }
        />

        <label
          style={
            styles.toggleContenedor
          }
        >
          <input
            type="checkbox"
            checked={
              verTodos
            }
            onChange={(e) => {
              const activo =
                e.target.checked;

              setVerTodos(
                activo
              );

              if (
                !activo &&
                filtroPrioridad ===
                  "ocurridos"
              ) {
                setFiltroPrioridad(
                  "todos"
                );
              }
            }}
            style={
              styles.toggleCheckbox
            }
          />

          <span
            style={{
              ...styles.toggleSwitch,

              ...(verTodos
                ? styles.toggleSwitchActivo
                : {}),
            }}
          >
            <span
              style={{
                ...styles.toggleCirculo,

                ...(verTodos
                  ? styles.toggleCirculoActivo
                  : {}),
              }}
            />
          </span>

          <span
            style={
              styles.toggleTexto
            }
          >
            {verTodos
              ? "Mostrando todos"
              : "Solo no resueltos"}
          </span>
        </label>

        {filtroPrioridad !==
          "todos" && (
          <button
            type="button"
            style={
              styles.limpiarFiltro
            }
            onClick={() =>
              setFiltroPrioridad(
                "todos"
              )
            }
          >
            Limpiar filtro
          </button>
        )}
      </div>

      {/* =====================================================
          RESULTADOS
      ===================================================== */}

      {cargando &&
      carpetas.length ===
        0 ? (
        <div
          style={
            styles.mensaje
          }
        >
          Cargando carpetas...
        </div>
      ) : carpetasOrdenadas.length ===
        0 ? (
        <div
          style={
            styles.mensaje
          }
        >
          No hay carpetas para
          mostrar.
        </div>
      ) : (
        configuracionGrupos.map(
          (grupo) => {
            const contenido =
              grupos[
                grupo.clave
              ];

            if (
              !contenido
            ) {
              return null;
            }

            return (
              <section
                key={
                  grupo.clave
                }
                style={
                  styles.seccionPrioridad
                }
              >
                <div
                  style={
                    styles.cabeceraPrioridad
                  }
                >
                  <div>
                    <div
                      style={
                        styles.tituloPrioridad
                      }
                    >
                      <span>
                        {
                          grupo.icono
                        }
                      </span>

                      {
                        grupo.titulo
                      }
                    </div>

                    <div
                      style={
                        styles.subtituloPrioridad
                      }
                    >
                      {
                        grupo.subtitulo
                      }
                    </div>
                  </div>

                  <div
                    style={
                      styles.contadorPrioridad
                    }
                  >
                    {contarElementos(
                      contenido
                    )}
                  </div>
                </div>

                {Object.entries(
                  contenido
                ).map(
                  ([
                    escuela,
                    sedes,
                  ]) => (
                    <div
                      key={
                        `${grupo.clave}-${escuela}`
                      }
                      style={
                        styles.grupoEscuela
                      }
                    >
                      <div
                        style={
                          styles.escuelaHeader
                        }
                      >
                        <span>
                          {
                            escuela
                          }
                        </span>

                        <span
                          style={
                            styles.contadorMini
                          }
                        >
                          {contarElementos(
                            sedes
                          )}{" "}
                          caso(s)
                        </span>
                      </div>

                      {Object.entries(
                        sedes
                      ).map(
                        ([
                          sede,
                          cursos,
                        ]) => (
                          <div
                            key={
                              `${escuela}-${sede}`
                            }
                            style={
                              styles.sedeGrupo
                            }
                          >
                            <div
                              style={
                                styles.sedeHeader
                              }
                            >
                              Sede{" "}
                              <b>
                                {
                                  sede
                                }
                              </b>
                            </div>

                            {Object.entries(
                              cursos
                            ).map(
                              ([
                                curso,
                                divisiones,
                              ]) => (
                                <div
                                  key={
                                    `${escuela}-${sede}-${curso}`
                                  }
                                  style={
                                    styles.cursoGrupo
                                  }
                                >
                                  <div
                                    style={
                                      styles.cursoHeader
                                    }
                                  >
                                    <span>
                                      {
                                        curso
                                      }
                                    </span>

                                    <span
                                      style={
                                        styles.contadorMini
                                      }
                                    >
                                      {contarElementos(
                                        divisiones
                                      )}
                                    </span>
                                  </div>

                                  {Object.entries(
                                    divisiones
                                  ).map(
                                    ([
                                      division,
                                      lista,
                                    ]) => (
                                      <div
                                        key={
                                          `${escuela}-${sede}-${curso}-${division}`
                                        }
                                        style={
                                          styles.divisionGrupo
                                        }
                                      >
                                        <div
                                          style={
                                            styles.divisionHeader
                                          }
                                        >
                                          División{" "}
                                          <b>
                                            {
                                              division
                                            }
                                          </b>

                                          <span
                                            style={
                                              styles.contadorDivision
                                            }
                                          >
                                            {
                                              lista.length
                                            }{" "}
                                            caso(s)
                                          </span>
                                        </div>

                                        <div
                                          style={
                                            styles.listaCompacta
                                          }
                                        >
                                          {lista.map(
                                            (
                                              carpeta
                                            ) => {
                                              const prioridad =
                                                obtenerPrioridad(
                                                  carpeta
                                                );

                                              const abierta =
                                                carpetaExpandidaId ===
                                                carpeta.carpetaId;

                                              return (
                                                <CarpetaCompacta
                                                  key={
                                                    carpeta.carpetaId
                                                  }
                                                  carpeta={
                                                    carpeta
                                                  }
                                                  prioridad={
                                                    prioridad
                                                  }
                                                  abierta={
                                                    abierta
                                                  }
                                                  guardando={
                                                    guardandoIntervencion
                                                  }
                                                  onToggle={() =>
                                                    setCarpetaExpandidaId(
                                                      abierta
                                                        ? null
                                                        : carpeta.carpetaId
                                                    )
                                                  }
                                                  onIntervenir={
                                                    intervenirSanidad
                                                  }
                                                  onDictaminarDocumento={
                                                    dictaminarDocumento
                                                  }
                                                  guardandoDocumentoId={
                                                    guardandoDocumentoId
                                                  }
                                                  formatearFecha={
                                                    formatearFecha
                                                  }
                                                  formatearFechaHora={
                                                    formatearFechaHora
                                                  }
                                                  formatearTipoAusencia={
                                                    formatearTipoAusencia
                                                  }
                                                />
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        )
                      )}
                    </div>
                  )
                )}
              </section>
            );
          }
        )
      )}
    </div>
  );
};

// ============================================================
// CARPETA COMPACTA
// ============================================================

const CarpetaCompacta = ({
  carpeta,
  prioridad,
  abierta,
  guardando,
  onToggle,
  onIntervenir,
  onDictaminarDocumento,
  guardandoDocumentoId,
  formatearFecha,
  formatearFechaHora,
  formatearTipoAusencia,
}) => {
  const docente =
    carpeta.docente ||
    {};

  const info =
    carpeta
      .informacionAcademica ||
    {};

  const documentos =
    Array.isArray(
      carpeta.documentos
    )
      ? carpeta.documentos
      : [];

  const intervenciones =
    Array.isArray(
      carpeta
        .intervencionesSanidad
    )
      ? carpeta
          .intervencionesSanidad
      : [];

  const resuelta =
    [
      "Justificado",
      "Injustificado",
    ].includes(
      carpeta.estadoSanidad
    );

  return (
    <div
      style={{
        ...styles.carpetaContenedor,

        ...(prioridad.clave ===
        "criticos"
          ? styles.carpetaCritica
          : {}),
      }}
    >
      {/* =====================================================
          CABECERA COMPACTA
      ===================================================== */}

      <button
        type="button"
        onClick={
          onToggle
        }
        style={
          styles.carpetaFila
        }
      >
        <div
          style={
            styles.docenteColumna
          }
        >
          <div
            style={
              styles.docenteNombre
            }
          >
            {docente.nombreCompleto ||
              `DNI ${carpeta.docenteDni}`}
          </div>

          <div
            style={
              styles.docenteDni
            }
          >
            DNI{" "}
            {docente.dni ||
              carpeta.docenteDni}
          </div>
        </div>

        <div
          style={
            styles.periodoColumna
          }
        >
          <div>
            {formatearFecha(
              carpeta.fechaDesde
            )}
            {" → "}
            {formatearFecha(
              carpeta.fechaHasta
            )}
          </div>

          <div
            style={
              styles.diasMini
            }
          >
            Solicitados: {carpeta.diasSolicitados ?? 0}
            {" · "}
            Otorgados: {obtenerDiasConfirmados(carpeta) ?? "Sin resolver"}
          </div>
        </div>

        <div
          style={
            styles.materiaColumna
          }
        >
          <div
            style={
              styles.materiaNombre
            }
          >
            {info.materia ||
              "Materia no informada"}
          </div>

          <div
            style={
              styles.destinoMini
            }
          >
            {info.escuela ||
              "-"}
            {" · "}
            {info.sede ||
              "-"}
            {" · "}
            {info.curso ||
              "-"}
            {" · Div. "}
            {info.division ||
              "-"}
          </div>
        </div>

        <div
          style={
            styles.estadoColumna
          }
        >
          <PrioridadBadge
            prioridad={
              prioridad
            }
          />

          <EstadoSanidad
            estado={
              carpeta.estadoSanidad
            }
          />

          <span
            style={
              styles.chevron
            }
          >
            {abierta
              ? "▲"
              : "▼"}
          </span>
        </div>
      </button>

      {/* =====================================================
          DETALLE
      ===================================================== */}

      {abierta && (
        <div
          style={
            styles.detalleExpandido
          }
        >
          {/* PRIORIDAD */}

          {prioridad.clave ===
            "criticos" && (
            <div
              style={
                styles.alertaCritica
              }
            >
              <b>
                ⚠  Atención
                prioritaria
              </b>

              <span>
                {
                  prioridad.descripcion
                }
              </span>
            </div>
          )}

          {/* INFORMACIÓN PRINCIPAL */}

          <div
            style={
              styles.gridMini
            }
          >
            <DatoMini
              titulo="Motivo"
              valor={
                formatearTipoAusencia(
                  carpeta.tipoDeAusencia
                )
              }
            />

            <DatoMini
              titulo="Desde"
              valor={
                formatearFecha(
                  carpeta.fechaDesde
                )
              }
            />

            <DatoMini
              titulo="Hasta"
              valor={
                formatearFecha(
                  carpeta.fechaHasta
                )
              }
            />

            <DatoMini
              titulo="Días solicitados"
              valor={
                carpeta.diasSolicitados
              }
            />

            <DatoMini
              titulo="Días otorgados"
              valor={
                obtenerDiasConfirmados(carpeta) ??
                "Sin resolver"
              }
            />

            <DatoMini
              titulo="Estado"
              valor={
                carpeta.estadoSanidad
              }
            />

            <DatoMini
              titulo="Documentos"
              valor={
                documentos.length
              }
            />
          </div>

          {/* DOCUMENTACIÓN PARA DICTAMEN */}

          <DocumentacionCarpetaSanidad
            carpeta={carpeta}
            documentos={documentos}
            guardandoDocumentoId={guardandoDocumentoId}
            onDictaminarDocumento={onDictaminarDocumento}
            formatearFechaHora={formatearFechaHora}
          />

          {/* ACCIONES */}

          <DetalleSeccion
            titulo="Intervención de Sanidad"
          >
            <div
              style={
                styles.seleccioneAccion
              }
            >
              {carpeta.estadoSanidad &&
              carpeta.estadoSanidad !== "Pendiente"
                ? `Estado actual: ${carpeta.estadoSanidad}`
                : "Seleccione una opción"}
            </div>

            <div
              style={
                styles.botonesAccion
              }
            >
              <button
                type="button"
                disabled={
                  guardando
                }
                style={{
                  ...styles.botonAccionNeutro,
                  ...(carpeta.estadoSanidad === "En Revision"
                    ? styles.botonAccionSeleccionado
                    : {}),
                }}
                onClick={() =>
                  onIntervenir(
                    carpeta,
                    "En Revision"
                  )
                }
              >
                En revisión
              </button>

              <button
                type="button"
                disabled={
                  guardando
                }
                style={{
                  ...styles.botonAccionNeutro,
                  ...(carpeta.estadoSanidad === "Justificado"
                    ? styles.botonAccionSeleccionado
                    : {}),
                }}
                onClick={() =>
                  onIntervenir(
                    carpeta,
                    "Justificado"
                  )
                }
              >
                Justificar
              </button>

              <button
                type="button"
                disabled={
                  guardando
                }
                style={{
                  ...styles.botonAccionNeutro,
                  ...(carpeta.estadoSanidad === "Injustificado"
                    ? styles.botonAccionSeleccionado
                    : {}),
                }}
                onClick={() =>
                  onIntervenir(
                    carpeta,
                    "Injustificado"
                  )
                }
              >
                Injustificar
              </button>
            </div>

            {resuelta && (
              <div
                style={
                  styles.avisoResuelto
                }
              >
                Esta carpeta ya tiene
                resolución de Sanidad.
                Puede intervenir
                nuevamente si debe
                rectificarse.
              </div>
            )}
          </DetalleSeccion>

          {/* DOCENTE */}

          <DetalleSeccion
            titulo="Docente"
          >
            <div
              style={
                styles.gridMini
              }
            >
              <DatoMini
                titulo="Apellido"
                valor={
                  docente.apellido
                }
              />

              <DatoMini
                titulo="Nombres"
                valor={
                  docente.nombres
                }
              />

              <DatoMini
                titulo="DNI"
                valor={
                  docente.dni ||
                  carpeta.docenteDni
                }
              />

              <DatoMini
                titulo="Teléfono"
                valor={
                  docente.telefono
                }
              />

              <DatoMini
                titulo="Correo"
                valor={
                  docente.email
                }
              />
            </div>
          </DetalleSeccion>

          {/* DESTINO */}

          <DetalleSeccion
            titulo="Actividad docente afectada"
          >
            <div
              style={
                styles.gridMini
              }
            >
              <DatoMini
                titulo="Escuela"
                valor={
                  info.escuela
                }
              />

              <DatoMini
                titulo="Sede"
                valor={
                  info.sede
                }
              />

              <DatoMini
                titulo="Curso"
                valor={
                  info.curso
                }
              />

              <DatoMini
                titulo="División"
                valor={
                  info.division
                }
              />

              <DatoMini
                titulo="Materia"
                valor={
                  info.materia
                }
              />
            </div>
          </DetalleSeccion>

          {/* ÚLTIMA INTERVENCIÓN */}

          {carpeta
            .fechaIntervencionSanidad && (
            <DetalleSeccion
              titulo="Última intervención"
            >
              <div
                style={
                  styles.gridMini
                }
              >
                <DatoMini
                  titulo="Fecha"
                  valor={
                    formatearFechaHora(
                      carpeta
                        .fechaIntervencionSanidad
                    )
                  }
                />

                <DatoMini
                  titulo="Usuario"
                  valor={
                    carpeta
                      .usuarioSanidadId
                  }
                />

                <DatoMini
                  titulo="Estado"
                  valor={
                    carpeta
                      .estadoSanidad
                  }
                />
              </div>

              {carpeta
                .observacionesSanidad && (
                <div
                  style={
                    styles.observacion
                  }
                >
                  {
                    carpeta
                      .observacionesSanidad
                  }
                </div>
              )}
            </DetalleSeccion>
          )}

          {/* HISTORIAL */}

          {intervenciones.length >
            0 && (
            <DetalleSeccion
              titulo="Historial de Sanidad"
            >
              <div
                style={
                  styles.historialLista
                }
              >
                {[
                  ...intervenciones,
                ]
                  .sort(
                    (a, b) =>
                      new Date(
                        b.fechaIntervencion ||
                          b.createdAt ||
                          0
                      ) -
                      new Date(
                        a.fechaIntervencion ||
                          a.createdAt ||
                          0
                      )
                  )
                  .map(
                    (
                      item,
                      index
                    ) => (
                      <div
                        key={
                          item.id ||
                          index
                        }
                        style={
                          styles.historialItem
                        }
                      >
                        <div
                          style={
                            styles.historialHeader
                          }
                        >
                          <EstadoSanidad
                            estado={
                              item.estadoNuevo ||
                              item.estado ||
                              item.resultado ||
                              item.accion
                            }
                          />

                          <span
                            style={
                              styles.fechaHistorial
                            }
                          >
                            {formatearFechaHora(
                              item.fechaIntervencion ||
                                item.createdAt
                            )}
                          </span>
                        </div>

                        {(item.observacion ||
                          item.observaciones) && (
                          <div
                            style={
                              styles.historialObservacion
                            }
                          >
                            {item.observacion ||
                              item.observaciones}
                          </div>
                        )}
                      </div>
                    )
                  )}
              </div>
            </DetalleSeccion>
          )}
        </div>
      )}
    </div>
  );
};

// ============================================================
// DOCUMENTACIÓN DE LA CARPETA PARA SANIDAD
// ============================================================

const DocumentacionCarpetaSanidad = ({
  carpeta,
  documentos,
  guardandoDocumentoId,
  onDictaminarDocumento,
  formatearFechaHora,
}) => {
  const formatearTamano = (bytes) => {
    const numero = Number(bytes || 0);
    if (!numero) return "Tamaño no informado";
    if (numero < 1024) return `${numero} B`;
    if (numero < 1024 * 1024) return `${(numero / 1024).toFixed(1)} KB`;
    return `${(numero / (1024 * 1024)).toFixed(1)} MB`;
  };

  const urlDocumento = (documento) => {
    if (documento?.id) {
      return `${API_DOCUMENTOS}/${documento.url}`;
    }

    if (/^https?:\/\//i.test(documento?.url || "")) {
      return documento.url;
    }

    return null;
  };

  return (
    <DetalleSeccion titulo={`Documentación para revisar (${documentos.length})`}>
      {documentos.length === 0 ? (
        <div style={styles.alertaSinDocumentacion}>
          <b>Esta carpeta no tiene archivos adjuntos.</b>
          <span>Sanidad puede dejarla en revisión o resolverla según los antecedentes disponibles.</span>
        </div>
      ) : (
        <div style={styles.documentosLista}>
          {documentos.map((documento, index) => {
            const url = urlDocumento(documento);
            const guardando = guardandoDocumentoId === documento.id;

            return (
              <article key={documento.id || index} style={styles.documentoRevision}>
                <div style={styles.documentoCabecera}>
                <div style={styles.documentoIcono}>
  DOC
</div>

                  <div style={styles.documentoDatos}>
                    <b>{documento.nombre || documento.categoria || `Documento ${index + 1}`}</b>
                    <div style={styles.documentoMeta}>
                      {documento.categoria || "Sin categoría"}
                      {` · ${formatearTamano(documento.size)}`}
                      {documento.createdAt ? ` · ${formatearFechaHora(documento.createdAt)}` : ""}
                    </div>
                  </div>

                  <EstadoDocumento estado={documento.estado || "Presentado"} />
                </div>

                {documento.observaciones && (
                  <div style={styles.observacionDocumento}>
                    <b>Observación:</b> {documento.observaciones}
                  </div>
                )}

                <div style={styles.accionesDocumento}>
                  {url ? (
                    <a href={url} target="_blank" rel="noreferrer" style={styles.botonDocumento}>
                     Abrir archivo
                    </a>
                  ) : (
                    <span style={styles.archivoNoDisponible}>Archivo no disponible</span>
                  )}

                  <button
                    type="button"
                    disabled={guardando}
                    style={styles.botonDocumentoAceptar}
                    onClick={() => onDictaminarDocumento(carpeta, documento, "Aceptado")}
                  >
                    ✓ Aceptar
                  </button>

                  <button
                    type="button"
                    disabled={guardando}
                    style={styles.botonDocumentoObservar}
                    onClick={() => onDictaminarDocumento(carpeta, documento, "Observado")}
                  >
                    Observar
                  </button>

                  <button
                    type="button"
                    disabled={guardando}
                    style={styles.botonDocumentoRechazar}
                    onClick={() => onDictaminarDocumento(carpeta, documento, "Rechazado")}
                  >
                    Rechazar
                  </button>
                </div>

                {guardando && <div style={styles.guardandoDocumento}>Guardando dictamen...</div>}
              </article>
            );
          })}
        </div>
      )}
    </DetalleSeccion>
  );
};

const EstadoDocumento = ({ estado }) => {
  const valor = estado || "Presentado";
  const estilosEstado = {
    Aceptado: { color: "#087a55", background: "#e4f8ef" },
    Observado: { color: "#8a5b00", background: "#fff2ca" },
    Rechazado: { color: "#a12e2e", background: "#ffebeb" },
    "En Revision": { color: "#176691", background: "#e5f4fc" },
    Presentado: { color: "#31566e", background: "#edf4f8" },
  }[valor] || { color: "#4c6170", background: "#edf2f5" };

  return <span style={{ ...styles.estadoDocumento, ...estilosEstado }}>{valor}</span>;
};

// ============================================================
// RESUMEN
// ============================================================

const Resumen = ({
  numero,
  titulo,
  descripcion,
  onClick,
  activo,
  importante,
}) => (
  <button
    type="button"
    onClick={
      onClick
    }
    style={{
      ...styles.resumenCard,

      ...(activo
        ? styles.resumenActivo
        : {}),

      ...(importante &&
      numero > 0
        ? styles.resumenCritico
        : {}),
    }}
  >
    <div
      style={
        styles.resumenNumero
      }
    >
      {numero}
    </div>

    <div
      style={
        styles.resumenTitulo
      }
    >
      {titulo}
    </div>

    <div
      style={
        styles.resumenDescripcion
      }
    >
      {descripcion}
    </div>
  </button>
);

// ============================================================
// PRIORIDAD
// ============================================================

const PrioridadBadge = ({
  prioridad,
}) => {
  let estilo =
    styles.prioridadNormal;

  if (
    prioridad.clave ===
    "criticos"
  ) {
    estilo =
      styles.prioridadCritica;
  }

  if (
    prioridad.clave ===
    "proximos"
  ) {
    estilo =
      styles.prioridadProxima;
  }

  if (
    prioridad.clave ===
    "ocurridos"
  ) {
    estilo =
      styles.prioridadOcurrida;
  }

  return (
    <span
      title={
        prioridad.descripcion
      }
      style={{
        ...styles.badgePrioridad,
        ...estilo,
      }}
    >
      {
        prioridad.titulo
      }
    </span>
  );
};

// ============================================================
// ESTADO SANIDAD
// ============================================================

const EstadoSanidad = ({
  estado,
}) => {
  const valor =
    estado ||
    "Pendiente";

  let estilo =
    styles.estadoPendiente;

  if (
    valor ===
    "En Revision"
  ) {
    estilo =
      styles.estadoRevision;
  }

  if (
    valor ===
    "Justificado"
  ) {
    estilo =
      styles.estadoJustificado;
  }

  if (
    valor ===
    "Injustificado"
  ) {
    estilo =
      styles.estadoInjustificado;
  }

  return (
    <span
      style={{
        ...styles.badgeEstado,
        ...estilo,
      }}
    >
      {valor}
    </span>
  );
};

// ============================================================
// SECCIÓN
// ============================================================

const DetalleSeccion = ({
  titulo,
  children,
}) => (
  <div
    style={
      styles.detalleSeccion
    }
  >
    <div
      style={
        styles.detalleTitulo
      }
    >
      {titulo}
    </div>

    {children}
  </div>
);

// ============================================================
// DATO MINI
// ============================================================

const DatoMini = ({
  titulo,
  valor,
}) => (
  <div
    style={
      styles.datoMini
    }
  >
    <div
      style={
        styles.datoMiniTitulo
      }
    >
      {titulo}
    </div>

    <div
      style={
        styles.datoMiniValor
      }
    >
      {valor !== null &&
      valor !== undefined &&
      valor !== ""
        ? valor
        : "-"}
    </div>
  </div>
);

// ============================================================
// CONTADOR RECURSIVO
// ============================================================

const contarElementos =
  (objeto) => {
    if (
      Array.isArray(
        objeto
      )
    ) {
      return objeto.length;
    }

    if (
      !objeto ||
      typeof objeto !==
        "object"
    ) {
      return 0;
    }

    return Object.values(
      objeto
    ).reduce(
      (total, valor) =>
        total +
        contarElementos(
          valor
        ),
      0
    );
  };

// ============================================================
// ESTILOS
// ============================================================

const styles = {
  contenedor: {
    width: "100%",
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "16px",
    boxSizing:
      "border-box",
  },

  header: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems:
      "center",
    flexWrap:
      "wrap",
    gap: "12px",
    marginBottom:
      "14px",
  },

  titulo: {
    margin: 0,
    fontSize: "26px",
  },

  subtitulo: {
    marginTop: "3px",
    fontSize: "14px",
    opacity: 0.65,
  },

  botonActualizar: {
    border:
      "1px solid #ccc",
    borderRadius: "7px",
    background: "white",
    padding:
      "8px 13px",
    cursor: "pointer",
  },

  // ==========================================================
  // RESUMEN
  // ==========================================================

  resumenGrid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(135px, 1fr))",
    gap: "7px",
    marginBottom:
      "12px",
  },

  resumenCard: {
    textAlign: "left",
    border:
      "1px solid #e1e1e1",
    borderRadius: "8px",
    padding:
      "10px 12px",
    background: "white",
    cursor: "pointer",
  },

  resumenActivo: {
    outline:
      "2px solid #777",
  },

  resumenCritico: {
    border:
      "1px solid #d8a3a3",
    background:
      "#fff5f5",
  },

  resumenNumero: {
    fontSize: "23px",
    fontWeight: "900",
    lineHeight: 1,
  },

  resumenTitulo: {
    marginTop: "5px",
    fontSize: "13px",
    fontWeight: "800",
  },

  resumenDescripcion: {
    marginTop: "2px",
    fontSize: "11px",
    opacity: 0.6,
  },

  // ==========================================================
  // HERRAMIENTAS
  // ==========================================================

  barraHerramientas: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "7px",
    marginBottom:
      "14px",
  },

  buscador: {
    flex: 1,
    minWidth: 0,
    padding:
      "10px 12px",
    boxSizing:
      "border-box",
    border:
      "1px solid #ccc",
    borderRadius: "8px",
    fontSize: "14px",
  },

  limpiarFiltro: {
    border:
      "1px solid #ccc",
    borderRadius: "8px",
    background: "white",
    padding:
      "8px 12px",
    cursor: "pointer",
    whiteSpace:
      "nowrap",
  },

  toggleContenedor: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 10px",
    border:
      "1px solid #d8d8d8",
    borderRadius: "8px",
    background: "white",
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
  },

  toggleCheckbox: {
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
  },

  toggleSwitch: {
    position: "relative",
    width: "38px",
    height: "21px",
    borderRadius: "999px",
    background: "#d5d9de",
    transition:
      "all .2s ease",
    flexShrink: 0,
  },

  toggleSwitchActivo: {
    background: "#172f4d",
  },

  toggleCirculo: {
    position: "absolute",
    top: "3px",
    left: "3px",
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    background: "white",
    boxShadow:
      "0 1px 3px rgba(0,0,0,.25)",
    transition:
      "all .2s ease",
  },

  toggleCirculoActivo: {
    left: "20px",
  },

  toggleTexto: {
    fontSize: "12px",
    fontWeight: "800",
    color: "#344054",
  },

  mensaje: {
    padding: "30px",
    textAlign: "center",
    opacity: 0.65,
  },

  // ==========================================================
  // PRIORIDAD
  // ==========================================================

  seccionPrioridad: {
    marginBottom:
      "22px",
  },

  cabeceraPrioridad: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems:
      "center",
    gap: "10px",
    marginBottom: "8px",
  },

  tituloPrioridad: {
    display: "flex",
    alignItems:
      "center",
    gap: "7px",
    fontSize: "19px",
    fontWeight: "900",
  },

  subtituloPrioridad: {
    marginTop: "2px",
    fontSize: "12px",
    opacity: 0.6,
  },

  contadorPrioridad: {
    minWidth: "30px",
    height: "30px",
    border:
      "1px solid #ddd",
    borderRadius: "15px",
    display: "flex",
    alignItems:
      "center",
    justifyContent:
      "center",
    fontSize: "12px",
    fontWeight: "800",
  },

  // ==========================================================
  // AGRUPACIÓN
  // ==========================================================

  grupoEscuela: {
    border:
      "1px solid #ddd",
    borderRadius: "9px",
    overflow: "hidden",
    background: "white",
    marginBottom: "9px",
  },

  escuelaHeader: {
    display: "flex",
    justifyContent:
      "space-between",
    padding:
      "9px 11px",
    background:
      "#f5f5f5",
    fontSize: "14px",
    fontWeight: "900",
  },

  sedeGrupo: {
    borderTop:
      "1px solid #eee",
  },

  sedeHeader: {
    padding:
      "6px 11px",
    fontSize: "12px",
    background:
      "#fafafa",
  },

  cursoGrupo: {
    borderTop:
      "1px solid #f0f0f0",
  },

  cursoHeader: {
    display: "flex",
    justifyContent:
      "space-between",
    padding:
      "6px 15px",
    fontSize: "12px",
    fontWeight: "800",
  },

  divisionGrupo: {
    padding:
      "0 9px 8px 20px",
  },

  divisionHeader: {
    padding:
      "5px 0",
    display: "flex",
    alignItems:
      "center",
    gap: "7px",
    fontSize: "11px",
    opacity: 0.75,
  },

  contadorMini: {
    fontSize: "10px",
    opacity: 0.6,
  },

  contadorDivision: {
    fontSize: "10px",
    opacity: 0.6,
  },

  listaCompacta: {
    display: "flex",
    flexDirection:
      "column",
    gap: "5px",
  },

  // ==========================================================
  // CARPETA
  // ==========================================================

  carpetaContenedor: {
    border:
      "1px solid #e1e1e1",
    borderRadius: "7px",
    overflow: "hidden",
    background: "white",
  },

  carpetaCritica: {
    borderLeft:
      "4px solid #b95c5c",
  },

  carpetaFila: {
    width: "100%",
    border: "none",
    background: "white",

    display: "grid",

    gridTemplateColumns:
      "minmax(170px, 1fr) minmax(150px, .8fr) minmax(220px, 1.4fr) auto",

    gap: "10px",
    alignItems:
      "center",

    padding:
      "8px 10px",

    textAlign: "left",
    cursor: "pointer",
  },

  docenteColumna: {
    minWidth: 0,
  },

  docenteNombre: {
    fontSize: "13px",
    fontWeight: "800",
    whiteSpace:
      "nowrap",
    overflow: "hidden",
    textOverflow:
      "ellipsis",
  },

  docenteDni: {
    marginTop: "1px",
    fontSize: "10px",
    opacity: 0.55,
  },

  periodoColumna: {
    fontSize: "11px",
    fontWeight: "700",
  },

  diasMini: {
    marginTop: "2px",
    fontSize: "10px",
    opacity: 0.55,
  },

  materiaColumna: {
    minWidth: 0,
  },

  materiaNombre: {
    fontSize: "12px",
    fontWeight: "700",
    whiteSpace:
      "nowrap",
    overflow: "hidden",
    textOverflow:
      "ellipsis",
  },

  destinoMini: {
    marginTop: "2px",
    fontSize: "10px",
    opacity: 0.55,
    whiteSpace:
      "nowrap",
    overflow: "hidden",
    textOverflow:
      "ellipsis",
  },

  estadoColumna: {
    display: "flex",
    justifyContent:
      "flex-end",
    alignItems:
      "center",
    flexWrap: "wrap",
    gap: "4px",
  },

  chevron: {
    fontSize: "9px",
    opacity: 0.5,
  },

  // ==========================================================
  // BADGES
  // ==========================================================

  badgePrioridad: {
    display:
      "inline-flex",
    border:
      "1px solid #ddd",
    borderRadius: "12px",
    padding:
      "3px 6px",
    fontSize: "9px",
    fontWeight: "900",
    whiteSpace:
      "nowrap",
  },

  prioridadCritica: {
    background:
      "#fff1f1",
    borderColor:
      "#d29b9b",
  },

  prioridadProxima: {
    background:
      "#fff8e6",
    borderColor:
      "#d9bd72",
  },

  prioridadOcurrida: {
    background:
      "#f1f6f1",
    borderColor:
      "#adc4ad",
  },

  prioridadNormal: {
    background:
      "#f6f6f6",
  },

  badgeEstado: {
    border:
      "1px solid #ddd",
    borderRadius: "12px",
    padding:
      "3px 6px",
    fontSize: "9px",
    fontWeight: "800",
    whiteSpace:
      "nowrap",
  },

  estadoPendiente: {
    background:
      "#fff8e1",
    borderColor:
      "#d9bd72",
  },

  estadoRevision: {
    background:
      "#edf3ff",
    borderColor:
      "#aabce0",
  },

  estadoJustificado: {
    background:
      "#edf8ef",
    borderColor:
      "#9ec5a4",
  },

  estadoInjustificado: {
    background:
      "#fff0f0",
    borderColor:
      "#d5a1a1",
  },

  // ==========================================================
  // DETALLE
  // ==========================================================

  detalleExpandido: {
    padding:
      "12px",
    borderTop:
      "1px solid #eee",
    background:
      "#fcfcfc",
  },

  alertaCritica: {
    display: "flex",
    flexDirection:
      "column",
    gap: "2px",
    border:
      "1px solid #d6a1a1",
    background:
      "#fff4f4",
    borderRadius: "7px",
    padding:
      "8px 10px",
    fontSize: "11px",
    marginBottom: "9px",
  },

  gridMini: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(135px, 1fr))",
    gap: "5px",
  },

  datoMini: {
    border:
      "1px solid #e7e7e7",
    borderRadius: "6px",
    padding:
      "6px 8px",
    background: "white",
    minWidth: 0,
  },

  datoMiniTitulo: {
    fontSize: "9px",
    opacity: 0.55,
    marginBottom: "2px",
  },

  datoMiniValor: {
    fontSize: "11px",
    fontWeight: "700",
    wordBreak:
      "break-word",
  },

  detalleSeccion: {
    borderTop:
      "1px solid #e8e8e8",
    marginTop: "9px",
    paddingTop: "9px",
  },

  detalleTitulo: {
    marginBottom:
      "6px",
    fontSize: "12px",
    fontWeight: "900",
  },

  // ==========================================================
  // ACCIONES
  // ==========================================================

  seleccioneAccion: {
    marginBottom: "8px",
    color: "#667085",
    fontSize: "12px",
    fontWeight: "700",
  },

  botonesAccion: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
  },

  botonAccionNeutro: {
    border:
      "1px solid #c7cdd4",
    borderRadius: "6px",
    background: "white",
    color: "#344054",
    padding:
      "7px 11px",
    fontSize: "11px",
    fontWeight: "700",
    cursor: "pointer",
  },

  botonAccionSeleccionado: {
    border:
      "1px solid #172f4d",
    borderRadius: "6px",
    background: "#172f4d",
    color: "#ffffff",
    padding:
      "7px 11px",
    fontSize: "11px",
    fontWeight: "800",
    cursor: "pointer",
    boxShadow:
      "0 2px 7px rgba(23, 47, 77, 0.22)",
  },

  botonSecundario: {
    border:
      "1px solid #bbb",
    borderRadius: "6px",
    background: "white",
    padding:
      "7px 10px",
    fontSize: "11px",
    cursor: "pointer",
  },

  botonPrincipal: {
    border:
      "1px solid #222",
    borderRadius: "6px",
    background: "#222",
    color: "white",
    padding:
      "7px 11px",
    fontSize: "11px",
    fontWeight: "800",
    cursor: "pointer",
  },

  botonPeligro: {
    border:
      "1px solid #999",
    borderRadius: "6px",
    background: "white",
    padding:
      "7px 10px",
    fontSize: "11px",
    fontWeight: "700",
    cursor: "pointer",
  },

  avisoResuelto: {
    marginTop: "7px",
    padding:
      "7px 9px",
    border:
      "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "10px",
  },

  observacion: {
    marginTop: "6px",
    padding:
      "7px 9px",
    border:
      "1px solid #ddd",
    borderRadius: "6px",
    background: "white",
    fontSize: "11px",
    whiteSpace:
      "pre-wrap",
  },

  // ==========================================================
  // DOCUMENTOS
  // ==========================================================

  documentosLista: {
    display: "flex",
    flexDirection:
      "column",
    gap: "4px",
  },

  documentoFila: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems:
      "center",
    gap: "10px",
    border:
      "1px solid #e5e5e5",
    borderRadius: "6px",
    background: "white",
    padding:
      "7px 8px",
    fontSize: "11px",
  },

  documentoMeta: {
    marginTop: "2px",
    fontSize: "9px",
    opacity: 0.55,
  },

  botonDocumento: {
    border:
      "1px solid #ccc",
    borderRadius: "5px",
    padding:
      "5px 8px",
    textDecoration: "none",
    color: "inherit",
    fontSize: "10px",
    whiteSpace:
      "nowrap",
  },

  alertaSinDocumentacion: {
    display: "flex",
    flexDirection: "column",
    gap: "3px",
    padding: "9px 10px",
    border: "1px solid #ead9aa",
    borderRadius: "7px",
    background: "#fff9e9",
    color: "#705415",
    fontSize: "10px",
  },

  documentoRevision: {
    display: "grid",
    gap: "8px",
    padding: "10px",
    border: "1px solid #dbe6ec",
    borderRadius: "8px",
    background: "white",
  },

  documentoCabecera: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  documentoIcono: {
    display: "grid",
    placeItems: "center",
    width: "30px",
    height: "30px",
    flex: "0 0 30px",
    borderRadius: "7px",
    background: "#edf6fa",
    fontSize: "16px",
  },

  documentoDatos: {
    flex: 1,
    minWidth: 0,
    fontSize: "11px",
    overflowWrap: "anywhere",
  },

  estadoDocumento: {
    padding: "4px 7px",
    borderRadius: "999px",
    fontSize: "9px",
    fontWeight: "900",
    whiteSpace: "nowrap",
  },

  observacionDocumento: {
    padding: "7px 8px",
    borderLeft: "3px solid #d69b23",
    borderRadius: "5px",
    background: "#fff9e9",
    fontSize: "10px",
  },

  accionesDocumento: {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
  },

  botonDocumentoAceptar: {
    border: "1px solid #8bc8ad",
    borderRadius: "5px",
    padding: "5px 8px",
    background: "#e7f7ef",
    color: "#146447",
    fontSize: "10px",
    fontWeight: "800",
    cursor: "pointer",
  },

  botonDocumentoObservar: {
    border: "1px solid #d8bd70",
    borderRadius: "5px",
    padding: "5px 8px",
    background: "#fff5d8",
    color: "#765300",
    fontSize: "10px",
    fontWeight: "800",
    cursor: "pointer",
  },

  botonDocumentoRechazar: {
    border: "1px solid #d8a2a2",
    borderRadius: "5px",
    padding: "5px 8px",
    background: "#ffeded",
    color: "#8c2929",
    fontSize: "10px",
    fontWeight: "800",
    cursor: "pointer",
  },

  archivoNoDisponible: {
    padding: "5px 8px",
    color: "#777",
    fontSize: "10px",
  },

  guardandoDocumento: {
    color: "#176691",
    fontSize: "10px",
    fontWeight: "700",
  },

  // ==========================================================
  // HISTORIAL
  // ==========================================================

  historialLista: {
    display: "flex",
    flexDirection:
      "column",
    gap: "5px",
  },

  historialItem: {
    border:
      "1px solid #e4e4e4",
    borderRadius: "6px",
    background: "white",
    padding:
      "7px 8px",
  },

  historialHeader: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems:
      "center",
    gap: "8px",
  },

  fechaHistorial: {
    fontSize: "9px",
    opacity: 0.55,
  },

  historialObservacion: {
    marginTop: "5px",
    fontSize: "10px",
    lineHeight: 1.4,
  },

  vacio: {
    padding: "8px",
    border:
      "1px solid #e5e5e5",
    borderRadius: "6px",
    background: "white",
    fontSize: "10px",
    opacity: 0.65,
  },
};

export default ModuloSanidadAusenciasDocentes;